import React, { useState, useEffect } from 'react';

export default function RegisterUser() {
    useEffect(() => {
  const getSession = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/session`, {
        credentials: 'include'
      });
      const data = await res.json();
  if (!data.success) {
  window.location.href = '/login';
}

    } catch (err) {
      window.location.href = '/';
    }
  };
  getSession();
}, []);

  const [form, setForm] = useState({
  name: '',
  email: '',
  password: '',
  role: 'admin',
  organization_id: '',
  department_id: '',
  memo_contract_id: '',
  memo_pbp_id: '',
  memo_role: '',
  cap_role: '',
  scrubber_role: '',
  scrubber_scopes: [],
  app_roles: {
    memo: false,
    cap: false,
    scrubber: false,
    contract: false
  }
});



  const [departments, setDepartments] = useState([]);
  const [contracts, setContracts] = useState([]);
const [pbps, setPbps] = useState([]);

  const [message, setMessage] = useState('');
const [selectedApp, setSelectedApp] = useState('');

// Available Scrubber protocols
const SCRUBBER_PROTOCOLS = [
  { code: 'ODAG', name: 'ODAG', desc: 'Org. Determinations, Appeals & Grievances' },
  { code: 'CDAG', name: 'CDAG', desc: 'Coverage Determinations & Appeals' },
  { code: 'FA', name: 'FA', desc: 'Formal Appeals' },
  { code: 'SNPCC', name: 'SNPCC', desc: 'SNP Model of Care / Care Coordination' }
];

// 🔹 Load departments
useEffect(() => {
  fetch(`${process.env.REACT_APP_API_URL}/api/departments`, {
    credentials: 'include'
  })
    .then(res => res.json())
    .then(data => {
      if (Array.isArray(data)) setDepartments(data);
    })
    .catch(err => console.error('❌ Failed to load departments:', err));
}, []);

// 🔹 Load contracts (with PBPs)
useEffect(() => {
  fetch(`${process.env.REACT_APP_API_URL}/api/contracts`, {
    credentials: 'include'
  })
    .then(res => res.json())
    .then(data => {
      if (data.success && Array.isArray(data.contracts)) {
        setContracts(data.contracts);
      }
    })
    .catch(err => console.error('❌ Failed to load contracts:', err));
}, []);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === 'memo' || name === 'cap' || name === 'scrubber' || name === 'contract') {
  setForm({
    ...form,
    app_roles: {
      ...form.app_roles,
      [name]: checked
    }
  });
}
else if (name === 'memo_contract_id') {
  const selected = contracts.find(c => c.id === value);
  const pbpList = selected?.pbps?.map(p => p.pbp_id) || [];
  setForm(prev => ({ ...prev, [name]: value, memo_pbp_id: '' }));
  setPbps(pbpList);
} else {
  setForm({ ...form, [name]: value });
}
  };

  const handleScopeChange = (protocolCode, checked) => {
    setForm(prev => ({
      ...prev,
      scrubber_scopes: checked 
        ? [...prev.scrubber_scopes, protocolCode]
        : prev.scrubber_scopes.filter(code => code !== protocolCode)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (form.app_roles.memo && (!form.memo_contract_id || !form.memo_pbp_id || !form.memo_role)) {
      setMessage('❌ Fill in Memo role, contract, and PBP');
      return;
    }
    
    if (form.app_roles.cap && !form.cap_role) {
      setMessage('❌ Fill in CAP role');
      return;
    }
    
    if (form.app_roles.scrubber && (!form.scrubber_role || form.scrubber_scopes.length === 0)) {
      setMessage('❌ Fill in Scrubber role and select at least one protocol scope');
      return;
    }

    const payload = { ...form };
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/users`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      if (data.success) {
        const userId = data.userId;

        // Assign Memo role if selected
        if (form.app_roles.memo) {
          const memoRes = await fetch(`${process.env.REACT_APP_API_URL}/api/app-roles/memo`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({
              user_id: userId,
              role: form.memo_role,
              department_id: form.department_id,
              contract_id: form.memo_contract_id,
              pbp_id: form.memo_pbp_id
            })
          });

          const memoData = await memoRes.json();
          if (!memoData.success) {
            console.error('❌ Failed to assign Memo role:', memoData.message);
            setMessage('❌ Failed to assign Memo access');
            return;
          }
        }

        // Assign CAP role if selected
        if (form.app_roles.cap) {
          const capRes = await fetch(`${process.env.REACT_APP_API_URL}/api/app-roles/cap`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({
              user_id: userId,
              role: form.cap_role,
              department_id: form.department_id,
              contract_id: form.memo_contract_id || null
            })
          });

          const capData = await capRes.json();
          if (!capData.success) {
            console.error('❌ Failed to assign CAP role:', capData.message);
            setMessage('❌ Failed to assign CAP access');
            return;
          }
        }

        // Assign Scrubber role and scopes if selected
        if (form.app_roles.scrubber) {
          // First assign the role
          const scrubberRes = await fetch(`${process.env.REACT_APP_API_URL}/api/app-roles/scrubber`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({
              user_id: userId,
              role: form.scrubber_role
            })
          });

          const scrubberData = await scrubberRes.json();
          if (!scrubberData.success) {
            console.error('❌ Failed to assign Scrubber role:', scrubberData.message);
            setMessage('❌ Failed to assign Scrubber access');
            return;
          }

          // Then assign the scopes
          const scopesRes = await fetch(`${process.env.REACT_APP_API_URL}/api/app-roles/scrubber/scopes`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({
              user_id: userId,
              protocol_codes: form.scrubber_scopes
            })
          });

          const scopesData = await scopesRes.json();
          if (!scopesData.success) {
            console.error('❌ Failed to assign Scrubber scopes:', scopesData.message);
            setMessage('❌ Failed to assign Scrubber scopes');
            return;
          }
        }

        setMessage(`✅ Created user: ${form.name}`);
        setForm({
  name: '',
  email: '',
  password: '',
  role: 'admin',
  organization_id: '',
  department_id: '',
  memo_contract_id: '',
  memo_pbp_id: '',
  memo_role: '',
  cap_role: '',
  scrubber_role: '',
  scrubber_scopes: [],
  app_roles: {
    memo: false,
    cap: false,
    scrubber: false,
    contract: false
  }
});
setPbps([]);


      } else {
        setMessage(`❌ ${data.message}`);
      }
    } catch (err) {
      console.error('❌ Registration failed:', err);
      setMessage('❌ Server error');
    }
  };

  return (
    <div className="p-6 max-w-xl mx-auto">
      <h2 className="text-xl font-bold mb-4">👤 Register User</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input name="name" placeholder="Full Name" value={form.name} onChange={handleChange} required className="w-full border p-2" />
        <input name="email" placeholder="Email" value={form.email} onChange={handleChange} required className="w-full border p-2" />
        <input name="password" placeholder="Password" value={form.password} onChange={handleChange} required className="w-full border p-2" />

        <select name="role" value={form.role} onChange={handleChange} required className="w-full border p-2">
          <option value="admin">Admin</option>
          <option value="associate">Associate</option>
          <option value="lead">Lead</option>
          <option value="supervisor">Supervisor</option>
          <option value="superuser">SuperUser</option>
          <option value="cap_developer">CAP Developer</option>
          <option value="cap_admin">CAP Admin</option>
        </select>

        <select name="department_id" value={form.department_id} onChange={handleChange} className="w-full border p-2">
          <option value="">(Optional) Assign Department</option>
          {departments.map(d => (
            <option key={d.id} value={d.id}>{d.name}</option>
          ))}
        </select>

        <div className="mb-4">
          <label className="block font-medium mb-1">Select Apps to Register</label>
          <div className="space-y-2">
            <label className="flex items-center">
              <input
                type="checkbox"
                name="memo"
                checked={form.app_roles.memo}
                onChange={handleChange}
                className="mr-2"
              />
              Memo
            </label>
            <label className="flex items-center">
              <input
                type="checkbox"
                name="cap"
                checked={form.app_roles.cap}
                onChange={handleChange}
                className="mr-2"
              />
              CAP
            </label>
            <label className="flex items-center">
              <input
                type="checkbox"
                name="scrubber"
                checked={form.app_roles.scrubber}
                onChange={handleChange}
                className="mr-2"
              />
              Scrubber
            </label>
            <label className="flex items-center">
              <input
                type="checkbox"
                name="contract"
                checked={form.app_roles.contract}
                onChange={handleChange}
                className="mr-2"
              />
              Contract
            </label>
          </div>
        </div>


        {/* Memo-specific role assignment */}
{form.app_roles.memo && (
  <div className="border p-4 mt-4 bg-gray-50 rounded">
    <h3 className="font-semibold mb-2">📄 Memo Access</h3>

    <select name="memo_contract_id" value={form.memo_contract_id || ''} onChange={handleChange} className="w-full border p-2 mb-2" required>
      <option value="">Select Contract</option>
{contracts.map(c => (
  <option key={c.id} value={c.id}>{c.name}</option>
))}

    </select>

    <select name="memo_pbp_id" value={form.memo_pbp_id || ''} onChange={handleChange} className="w-full border p-2 mb-2" required>
      <option value="">Select PBP</option>
{pbps.map(pbp => (
  <option key={pbp} value={pbp}>{pbp}</option>
))}

    </select>

    <select name="memo_role" value={form.memo_role || ''} onChange={handleChange} className="w-full border p-2" required>
      <option value="">Select Memo Role</option>
      <option value="admin">Admin</option>
      <option value="lead">Lead</option>
      <option value="supervisor">Supervisor</option>
      <option value="associate">Associate</option>
    </select>
  </div>
)}

        {/* CAP-specific role assignment */}
{form.app_roles.cap && (
  <div className="border p-4 mt-4 bg-blue-50 rounded">
    <h3 className="font-semibold mb-2">📊 CAP Access</h3>
    <select name="cap_role" value={form.cap_role || ''} onChange={handleChange} className="w-full border p-2" required>
      <option value="">Select CAP Role</option>
      <option value="admin">Admin</option>
      <option value="lead">Lead</option>
      <option value="validator">Validator</option>
      <option value="analyst">Analyst</option>
    </select>
  </div>
)}

        {/* Scrubber-specific role and scope assignment */}
{form.app_roles.scrubber && (
  <div className="border p-4 mt-4 bg-green-50 rounded">
    <h3 className="font-semibold mb-2">🔍 Scrubber Access</h3>
    
    <select name="scrubber_role" value={form.scrubber_role || ''} onChange={handleChange} className="w-full border p-2 mb-3" required>
      <option value="">Select Scrubber Role</option>
      <option value="analyst">Analyst</option>
      <option value="supervisor">Supervisor</option>
      <option value="admin">Admin</option>
    </select>

    <div className="mb-3">
      <label className="block font-medium mb-2">Select Protocol Scopes:</label>
      <div className="space-y-2">
        {SCRUBBER_PROTOCOLS.map(protocol => (
          <label key={protocol.code} className="flex items-center">
            <input
              type="checkbox"
              checked={form.scrubber_scopes.includes(protocol.code)}
              onChange={(e) => handleScopeChange(protocol.code, e.target.checked)}
              className="mr-2"
            />
            <span className="font-medium">{protocol.name}</span>
            <span className="text-sm text-gray-600 ml-2">({protocol.desc})</span>
          </label>
        ))}
      </div>
    </div>
  </div>
)}


        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">Register User</button>
        {message && <p className="text-sm text-blue-700 mt-2">{message}</p>}
      </form>
    </div>
  );
}
